import {
    PaymentMethod,
    PAYMENT_METHOD_ID,
    PaymentMethodGroups
} from '../constants';

export function findPaymentMethod(id: PAYMENT_METHOD_ID) {
    return PaymentMethodGroups
        .DEFAULT_PAYMENT_METHOD_GROUP
        .find((method) => method.id === id);
}

export function getPaymentMethodName(id: PAYMENT_METHOD_ID) {
    return findPaymentMethod(id)?.name;
}

export function hasPaymentMethod(
    paymentMethods: Array<PaymentMethod>,
    id: PAYMENT_METHOD_ID
) {
    return !!paymentMethods?.find((method) => method.id === id);
}

export function filterPaymentMethods(
    paymentMethods: Array<PaymentMethod>,
    whitelist: Array<PAYMENT_METHOD_ID>,
    exclude: boolean = false
): Array<PaymentMethod> {
    return paymentMethods?.filter(
        (method) => {
            const methodIncluded = whitelist?.includes(method.id);

            return exclude ? !methodIncluded : methodIncluded;
        }
    );
}
